import { apiRequest } from '@/utils/api-request';
import { NotificationStatusResponse } from '@/types/notification-types';
import * as Sentry from '@sentry/react';

export async function markNotificationRead(
  orgId: string,
  id: string,
): Promise<NotificationStatusResponse> {
  try {
    const response = await apiRequest<NotificationStatusResponse>({
      url: `/orgs/${orgId}/notifications/${id}/read`,
      target: 'notifications',
      method: 'PATCH',
    });

    return response.data ?? { status: 'ok' };
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'mark-notification-read', orgId, id },
    });
    throw error;
  }
}
